var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 mb-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
          from: 'from-resolution_blue',
          to: 'to-dodger_blue',
        }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.pageTitle.text)}})]),_c('p',{staticClass:"font-bold text-tundora text-xl mb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.pageSubTitle.text)}}),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"card break-inside-avoid"},[_c('image-with-descriptions',{attrs:{"options":{
              image:
                'pages/' +
                _vm.currentPage.slug +
                '/' +
                _vm.currentPage.images.image1.src,
              descriptions: [
                {
                  text: _vm.currentPage.images.image1.edf,
                  position: 'bottom-right', // top/bottom-left/right
                  orientation: 'horizontal', // vertical, horizontal
                } ],
            }}}),_c('TitleParagraph',{attrs:{"options":{
              from: 'from-resolution_blue',
              to: 'to-dodger_blue',
            }}},[_c('span',{staticClass:"text-xl lg:text-2xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.firstTitle.text)}})]),_c('TitleParagraph',{attrs:{"options":{
              from: 'from-resolution_blue',
              to: 'to-dodger_blue',
            }}},[_c('Triangles',{attrs:{"options":{
                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                direction: 'top',
              }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.firstSubTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
              color: 'text-nandor',
            }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.firstParagraph.text)}})])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
              from: 'from-resolution_blue',
              to: 'to-dodger_blue',
            }}},[_c('span',{staticClass:"text-xl lg:text-2xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.secondTitle.text)}})]),_c('TitleParagraph',{attrs:{"options":{
              from: 'from-resolution_blue',
              to: 'to-dodger_blue',
            }}},[_c('Triangles',{attrs:{"options":{
                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                direction: 'bottom',
              }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.secondSubTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
              color: 'text-nandor',
            }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.secondParagraph.text)}})]),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                image:
                  'pages/' +
                  _vm.currentPage.slug +
                  '/' +
                  _vm.currentPage.images.image2.src,
                descriptions: [
                  {
                    text: _vm.currentPage.images.image2.edf,
                    position: 'bottom-right', // top/bottom-left/right
                    orientation: 'horizontal', // vertical, horizontal
                  } ],
              }}})],1)],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                image:
                  'pages/' +
                  _vm.currentPage.slug +
                  '/' +
                  _vm.currentPage.images.image3.src,
                descriptions: [
                  {
                    text: _vm.currentPage.images.image3.edf,
                    position: 'bottom-right', // top/bottom-left/right
                    orientation: 'horizontal', // vertical, horizontal
                  } ],
              }}})],1),_c('TitleParagraph',{attrs:{"options":{
              from: 'from-resolution_blue',
              to: 'to-dodger_blue',
            }}},[_c('span',{staticClass:"text-xl lg:text-2xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.thirdTitle.text)}})]),_c('TitleParagraph',{attrs:{"options":{
              from: 'from-resolution_blue',
              to: 'to-dodger_blue',
            }}},[_c('Triangles',{attrs:{"options":{
                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                direction: 'top',
              }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.thirdSubTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
              color: 'text-nandor',
            }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.thirdParagraph.text)}})])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
              from: 'from-resolution_blue',
              to: 'to-dodger_blue',
            }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.firthSubTitle.text)}})]),_c('paragraph',{attrs:{"options":{
              color: 'text-nandor',
            }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.fourthParagraph.text)}}),_c('Triangles',{attrs:{"options":{
                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                direction: 'bottom',
              }}})],1),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                image:
                  'pages/' +
                  _vm.currentPage.slug +
                  '/' +
                  _vm.currentPage.images.image4.src,
                descriptions: [
                  {
                    text: _vm.currentPage.images.image4.edf,
                    position: 'bottom-right', // top/bottom-left/right
                    orientation: 'horizontal', // vertical, horizontal
                  } ],
              }}})],1)],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                image:
                  'pages/' +
                  _vm.currentPage.slug +
                  '/' +
                  _vm.currentPage.images.image5.src,
                descriptions: [
                  {
                    text: _vm.currentPage.images.image5.edf,
                    position: 'bottom-right', // top/bottom-left/right
                    orientation: 'horizontal', // vertical, horizontal
                  } ],
              }}})],1),_c('TitleParagraph',{attrs:{"options":{
              from: 'from-resolution_blue',
              to: 'to-dodger_blue',
            }}},[_c('Triangles',{attrs:{"options":{
                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                direction: 'top',
              }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sixthSubTitle.text)}})],1),_c('paragraph',{attrs:{"options":{
              color: 'text-nandor',
            }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.fifthParagraph.text)}})])],1)])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }